/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card__logout[_ngcontent-%COMP%]{margin:1.5rem 0;padding:1.5rem}.card__logout[_ngcontent-%COMP%]   mat-card-content[_ngcontent-%COMP%]{margin-top:1.5rem;display:flex;flex-direction:column}"];
export { styles as styles };
